// Settings tabs are sub-routes of `/settings`, not search params, so the
// browser agent can reach any tab by URL alone (ui-spec §7.2). Kebab-case
// slugs match the CONTEXT.md naming rule: "bank-accounts" (the entity
// CONTEXT.md reserves the word "account" for) is kept verbatim and
// distinct from "members" (the user-membership tab).

export const SETTINGS_TABS = [
  'profile',
  'bank-accounts',
  'members',
  'portal-credentials',
  'datev',
  'preferences',
  'sign-out',
] as const;

export type SettingsTab = (typeof SETTINGS_TABS)[number];

const VALID_TABS: ReadonlySet<string> = new Set(SETTINGS_TABS);

export function parseSettingsTab(value: unknown): SettingsTab | null {
  if (typeof value !== 'string') return null;
  return VALID_TABS.has(value) ? (value as SettingsTab) : null;
}

export function settingsTabPath(tab: SettingsTab): string {
  return `/settings/${tab}`;
}
